import { useCallback } from "react";

export const useSwitchAnchorOnProductChange = ({ products }) => {
	const switchAnchorOnProductChange = useCallback(
		(newIndex) => {
			const product = products[newIndex];

			// Setter by se měl postarat o to, že vždy produkt dostaneme
			if (!product) {
				console.error(
					"[INTERACTIVE PRODUCTS] Switch anchor. No product with index",
					newIndex,
					"inside",
					products
				);
				return;
			}

			const { pageAnchor } = product;

			// Pokud produkt nemá anchor, tak tuto funkcionalitu nemá zapnutou
			if (!pageAnchor) {
				return;
			}

			window.location.hash = pageAnchor;
		},
		[products]
	);

	return {
		switchAnchorOnProductChange,
	};
};
